// extracted by mini-css-extract-plugin
export default {"SelectorWrapper":"Select_SelectorWrapper__bdIXZ","title":"Select_title__BAs58","Select":"Select_Select__DNsQw","input":"Select_input__anIDn","inp_label":"Select_inp_label__rDVt7"};